import { render, staticRenderFns } from "./MemberTags.vue?vue&type=template&id=1c27af9f&lang=pug&"
import script from "./MemberTags.vue?vue&type=script&lang=js&"
export * from "./MemberTags.vue?vue&type=script&lang=js&"
import style0 from "./MemberTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports